import { intercept, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import { WellFooter } from 'src/Components/Footer/WellFooter';
import { ITaxRate } from 'src/Interfaces/AdminInterface';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { IContractor, IEngineer, IOperator, IRegion, IWarehouse, IWell } from '../../../../Interfaces/WellInterface';
import DataService from '../../../../Services/Data';
import ButtonRow from '../../../ButtonRow';
import DataTable from '../../../DataTable';
import { EButton, EInput } from '../../../EInput';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from "../WellRevertCloseButton";




interface IParams {
    wellId: string;
}

interface IList {
    headers: any[];
    rows: any[];
}

const dataService = new DataService();

@inject('stores')
@observer
class WellDetails extends React.Component {
    public props: any;
    private dataSet: IList;
    private params: IParams;
    private WellsStore: WellsStore;
    private UserStore: UserStore;
    private well: IWell = new IWell();

    private contractors: IContractor[] = [];
    private engineers: IEngineer[] = [];
    private operators: IOperator[] = [];
    private warehouses: IWarehouse[] = [];
    private counties: any[] = [];
    private usStates: any[] = [];
    public newEngineer: IEngineer = new IEngineer();

    // disposers
    public wellDisposer: any;
    public warehouseDisposer: any;
    public operatorDisposer: any;
    public regionDisposer: any;
    public contractorDisposer: any;
    public engineersDisposer: any;
    public statesDisposer: any;
    public countiesDisposer: any;
    private targetFormationDisposer: any;

    public state = {
        addEngineerModal: false,
        contractorList: this.contractors,
        countyList: this.counties,
        dataSet: this.dataSet,
        engineerList: this.engineers,
        formIsValid: false,
        isDirty: false,
        newEngineer: this.newEngineer,
        newWell: false,
        novaEmailList: [],
        operatorList: this.operators,
        regionList: [] as IRegion[],
        removeRowModal: false,
        saveClicked: false,
        selectedEngineer: '',
        targetFormationList: [],
        taxRates: [] as ITaxRate[],
        usStates: this.usStates,
        warehouseList: this.warehouses,
        warehouseSelected: new IWarehouse(),
        well: this.well,
        wellPageTitle: 'New Well',
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;
        this.params = this.props.match.params;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggleEngineerModal = this.toggleEngineerModal.bind(this);
        this.addEngineerToModel = this.addEngineerToModel.bind(this);
        this.handleEngineerSelection = this.handleEngineerSelection.bind(this);
        this.handleWarehouseSelection = this.handleWarehouseSelection.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.updateWellModel = this.updateWellModel.bind(this);
        this.getWarehouseDetails = this.getWarehouseDetails.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

    }

    public componentDidMount() {
        this.createDisposers();
        this.WellsStore.getRegions();
        this.WellsStore.getOperators();
        this.WellsStore.getContractors();
        this.WellsStore.getEngineers();
        this.WellsStore.getWarehouses();
        this.WellsStore.getUSStates();
        this.WellsStore.getTargetFormationOptions();
        this.WellsStore.getTaxRates()
            .then(data => {
                this.setState({
                    taxRates: data,
                });
            });
        if (!this.UserStore.user)
        {
            this.UserStore.getProfile();
        }

        if ( this.params.wellId === 'new' ) {
            this.setState({
                newWell: true,
                well: toJS(this.WellsStore.createNewWellInstance()),
            });
        } else {
            this.WellsStore.getWellDetails(this.params.wellId).then(()=> {
                if(this.state.well.state !== "") {
                    this.WellsStore.getCounties(this.state.well.state);
                }
            });
        }
        this.formatDataTable();
    }

    public componentWillUnmount() {

        this.wellDisposer();
        this.operatorDisposer();
        this.contractorDisposer();
        this.warehouseDisposer();
        this.statesDisposer();
        this.engineersDisposer();
        this.countiesDisposer(); 
        this.targetFormationDisposer();    
        this.regionDisposer();
    }

    public createDisposers() {
        this.wellDisposer = intercept(this.WellsStore, 'well', (change: any) => {
            let wellPageTitle = change.newValue.wellName;
                wellPageTitle = ( wellPageTitle === '' ) ? 'New Well' : wellPageTitle;
                
            this.setState({
                well: toJS(change.newValue),
                'wellPageTitle': wellPageTitle
            }, () => {
                this.formatDataTable();
            });
            this.isFormValid();
            return change;
        });

        this.operatorDisposer = intercept(this.WellsStore, 'operators', (change: any) => {
            this.setState({
                operatorList: change.newValue
            });

            return change;
        });

        this.regionDisposer = intercept(this.WellsStore, 'regions', (change: any) => {
            this.setState({
                regionList: change.newValue
            });

            return change;
        });

        this.contractorDisposer = intercept(this.WellsStore, 'contractors', (change: any) => {
            this.setState({
                contractorList: change.newValue
            });

            return change;
        });
        this.engineersDisposer = intercept(this.WellsStore, 'engineers', (change: any) => {
            this.setState({
                engineerList: change.newValue
            });

            return change;
        });
        this.warehouseDisposer = intercept(this.WellsStore, 'warehouses', (change: any) => {
            this.setState({
                warehouseList: change.newValue
            });

            return change;
        });
        this.statesDisposer = intercept(this.WellsStore, 'usStates', (change: any) => {
            this.setState({
                usStates: change.newValue
            });

            return change;
        });
        this.countiesDisposer = intercept(this.WellsStore, 'counties', (change: any) => {
            this.setState({
                countyList: change.newValue
            });

            return change;
        });

        this.targetFormationDisposer = intercept(this.WellsStore, 'targetFormationList', (change: any) => {
            this.setState({
                targetFormationList: change.newValue
            });
            return change;
        });
    }

    private formatDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'User',
            'Role',
            'Active',
            'Location',
            'Notifications',
            'Mobile Phone',
            'Alternate Phone',
        ];
        if ( this.state.well.engineers ) {
            this.state.well.engineers.map((engineer: IEngineer, index: number) => {
                const newObject = [
                    {
                        content: engineer.firstName + ' ' + engineer.lastName
                    },
                    {
                        content: engineer.roles[0] ? engineer.roles[0] : ''
                    },
                    {
                        content: this.renderActiveCheckbox(index, engineer),
                        type: 'render',
                    },
                    {
                        content: engineer.location
                    },
                    {
                        content: engineer.phoneNumber
                    },
                    {
                        content: engineer.phoneMobile
                    },
                    {
                        content: engineer.phoneAlternate
                    },
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            dataSet: listStructure
        });
    }

    private renderTaxRateOptions = () => {
        return (
            <React.Fragment>
            {
                this.state.taxRates.map(tr => 
                    <option key={tr.id} value={tr.rate}>{tr.rate}% - {tr.description}</option>
                )
            }
            </React.Fragment>
        );
    }
    private handleInputChange(event: any) {
        if(event.target.name === "state"){
            this.WellsStore.getCounties(event.target.value);
        }
        const well = this.state.well;
        well[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            well
        });
        this.isFormValid();
    }

    private handleDateChange(event: any) {
        const well = this.state.well;
        well[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            well
        });
        this.isFormValid();
    }

    private handleStateChange(event: any) {
        const well = this.state.well;
        well[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            well
        });
        this.WellsStore.getCounties(event.target.value);
    }

    private handleRegionChange = (event: any) => {
        const well = this.state.well;
        const operator = well.operator;
        const region = this.state.regionList.find(reg => reg.id === event.target.value);
        if (region ) {

            if (operator.id !== '') {
                const myRegion = operator.regions.find(or => or.id === event.target.value);
                if (myRegion) {
                    well.region = myRegion;
                    this.setState({
                        isDirty: true,
                        well
                    });
                } 
            } else {
                well.region = region;
                this.setState({
                    isDirty: true,
                    operatorList: region.operators,
                    well
                });
            }
        } else {
            well.region = new IRegion();
            this.setState({
                isDirty: true,
                operatorList: this.WellsStore.operators,
                well
            });
        }
    }

    private handleOperatorChange = (event: any) => {
        const well = this.state.well;
        const region = well.region;
        const operator = this.state.operatorList.find(op => op.id === event.target.value);
        if (operator) {
            if (region.id !== '') {
                const myOperator = region.operators.find(op => op.id === event.target.value);
                if (myOperator) {
                    well.operator = myOperator;
                    this.setState({
                        isDirty: true,
                        well
                    });
                }
            } else {
                well.operator = operator;
                this.setState({
                    isDirty: true,
                    regionList: operator.regions,
                    well,
                });
            }
        } else {
            well.operator = new IOperator();
            this.setState({
                isDirty: true,
                regionList: this.WellsStore.regions,
                well,
            });
        }
    }
    private handleSelectChange(event: any) {
        const well = this.state.well;
        const $name = event.target.name;
        const $value = event.target.value;
        const $wildArray = this.state[$name + 'List'];
        if ( $wildArray ) {
            $wildArray.forEach((row: any, index: number) => {
                if ( ($value).toString() === (row.id).toString() ) {
                    well[$name] = row;
                }
            });
            this.setState({
                isDirty: true,
                well
            });
        }
        this.isFormValid();
    }

    private toggleEngineerModal() {
        this.setState({
            addEngineerModal: !this.state.addEngineerModal,
            newEngineer: new IEngineer(),
            selectedEngineer: '',
            warehouseSelected: new IWarehouse(),
        });
    }

    private addEngineerToModel(event?: any) {
        const well = this.state.well;
        if ( this.state.newEngineer.id === "" ) {
            return;
        }
        well.engineers.push(this.state.newEngineer);
        this.setState({
            isDirty: true,
            newEngineer: new IEngineer(),
            selectedEngineer: '',
            warehouseSelected: new IWarehouse(),
            well,
        }, () => {
            this.formatDataTable();
        });
        if ( !event || event.target.id !== 'addAnother' ) {
            this.toggleEngineerModal();
        }
    }

    private getWarehouseDetails(warehouseId: string | number, field: string) {
        const warehouses = this.state.warehouseList;
        let value;
        warehouses.map((warehouse: any) => {
            if ( warehouse.id === warehouseId ) {
                value = warehouse[field];
            }
        });
        return value;
    }

    private handleEngineerSelection(event: any) {
        const engineers = this.state.engineerList;
        const newEngineer = engineers[event.target.value];
        newEngineer.active = true;
        this.setState({
            newEngineer,
            selectedEngineer: event.target.value,
        });
    }

    private handleWarehouseSelection = (event: any) => {
        const well = this.state.well;
        well.warehouseId = event.target.value;
        this.setState({well});
    }

    private handleKeyDown(event: any) {
        if ( event.keyCode === 13 ) {
            this.addEngineerToModel();
        }
    }

    private handleDelete(index: number) {
        const well = this.state.well;
        const items = well.engineers;
        items.splice(index,1);
        well.engineers = items;
        this.setState({
            isDirty: true,
            well
        });
        this.formatDataTable();
    }

    private updateWellModel(event?: any) {
        this.WellsStore.updateWellModel(this.state.well)
            .then(
                (data: any) => {
                    if ( data ) {
                        this.setState({
                            isDirty: false,
                            newWell: false,
                        });
                        this.props.history.push("/well/" + data.id + "/details");
                    }
                }
            );
    }

    private renderActiveCheckbox = ( index: number, eng: IEngineer ) => () => {
        return (

        <div className="multi-select-row">
            <Input 
                key={`${eng.id}-checkbox`}
                onChange={this.handleActiveCheck(index)}
                checked={eng.active}
                type="checkbox"
                value=""
                disabled={this.activeCheckDisabled(eng)}
            />
        </div>
        );
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        
        if ( $target.name === 'previous' ) {
            this.props.history.go(-1);
        } else {
            this.props.history.push('/well/' + this.state.well.id + '/location');
        }
    }

    public isFormValid() {
        const well = this.state.well;
        const isValid: boolean = (
            well.wellName === '' ||
            well.operator.id === '' ||
            well.contractor.id === '' ||
            well.rigNumber === ''
        );
        this.setState({
            formIsValid: isValid
        });
        return isValid;
    }

    private handleCountyChange = (event: any) => {
        const well = this.state.well;
        const timeZoneRow = this.state.countyList.find(value => value[0] === event.target.value);
        if (timeZoneRow) {
            well.timeZoneName = timeZoneRow[3];
        }
        well.countyParish = event.target.value;
        this.setState({
            dirty: true,
            well
        });
        
    }

    public handleActiveCheck = (index?: number) => (event: any) => {
        let eng: IEngineer;
        if (index !== undefined) {
            eng = this.state.well.engineers[index] as IEngineer;
        } else {
            eng = this.state.newEngineer;
        }
        eng.active = !eng.active;
        if (index !== undefined) {
            this.setState({
                well: this.state.well,
            });
        } else {
            this.setState({
                newEngineer: eng,
            });
        }
    }
    public isContractorAvailable(engineer: any) {
        const results: any[] = dataService.search(this.state.well.engineers, engineer.id.toString(), ['id']) || [];

        return ( results.length > 0 );
    }

    public activeCheckDisabled = (eng: IEngineer) => {
        if(!this.UserStore.user) {
            return true;
        }

        const activatePerm = this.UserStore.hasGenericPermission('Permissions.Wells.ActivateSupervisor');
        const deactivatePerm = this.UserStore.hasGenericPermission('Permissions.Wells.DeactivateSupervisor');
        if (eng.active && deactivatePerm)
        {
            if (this.UserStore.hasPermission('Permissions.Wells.DeactivateSupervisor.All')) {
                return !eng.isSupervisor;
            } else {
                return !eng.isSupervisor && this.state.well.engineers.some(engr => engr.id === this.UserStore.user.id);
            }
        } else if (!eng.active && activatePerm) {
            if (this.UserStore.hasPermission('Permissions.Wells.DeactivateSupervisor.All')) {
                return !eng.isSupervisor;
            } else {
                return !eng.isSupervisor && this.state.well.engineers.some(engr => engr.id === this.UserStore.user.id);
            }
        }
        return true;
        
    }

    private canAddEngineer = () => {
        const hasAllPerm = this.UserStore.hasPermission('Permissions.Wells.AddUser.All');
        if (hasAllPerm) {
            return true;
        }
        const hasAssignedPerm = this.UserStore.hasPermission('Permissions.Wells.AddUser.Assigned');
        if (hasAssignedPerm && this.state.well.engineers.some(eng => eng.id === this.UserStore.user.id)) {
            return true;
        }
        return false;
    }

    private canRemoveEngineer = () => {
        const hasAllPerm = this.UserStore.hasPermission('Permissions.Wells.RemoveUser.All');
        if (hasAllPerm) {
            return true;
        }
        const hasAssignedPerm = this.UserStore.hasPermission('Permissions.Wells.RemoveUser.Assigned');
        if (hasAssignedPerm && this.state.well.engineers.some(eng => eng.id === this.UserStore.user.id)) {
            return true;
        }
        return false;
    }
    public render() {
        const warehouse = this.state.warehouseList.find(w => w.id === this.state.well.warehouseId);
        const warehousePhone = warehouse ? warehouse.phone : '';
        return(
            <div>
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader wellSetupComplete={this.state.well.wellSetupComplete} workflowHeaderItems={this.props.workflowHeaderItems}/>
                <Form>
                    <Row>
                        <Col size={6}>
                            <Row>
                                <Col md="12" className="legend clearfix">
                                    <div className="required-legend">Required before a well can be created</div>
                                </Col>
                            </Row>
                            <FormGroup className="required">
                                <Label>Well Name</Label>
                                <EInput
                                    type="text"
                                    name="wellName"
                                    id="wellName"
                                    required={true}
                                    value={this.state.well.wellName}
                                    placeholder="Well Name"
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Operator</Label>
                                        {/* invalid={this.state.well.operator.id === ""} */}
                                        <EInput
                                            type="select"
                                            name="operator"
                                            id="operator"
                                            required={true}
                                            value={this.state.well.operator.id}
                                            onChange={this.handleOperatorChange}
                                            disabled={this.state.well.id !== ""}
                                        >
                                            <option />
                                            {this.state.operatorList.sort((a, b) => a.operatorName.localeCompare(b.operatorName)).map((operator: IOperator, index: number) =>
                                                <option key={operator.id} value={operator.id}>{operator.operatorName}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Region</Label>
                                        {/* invalid={this.state.well.operator.id === ""} */}
                                        <EInput
                                            type="select"
                                            name="region"
                                            id="region"
                                            required={true}
                                            value={this.state.well.region.id}
                                            onChange={this.handleRegionChange}
                                            disabled={this.state.well.id !== ""}
                                        >
                                            <option />
                                            {this.state.regionList.sort((a, b) => a.name.localeCompare(b.name)).map((region: IRegion, index: number) =>
                                                <option key={region.id} value={region.id}>{region.name}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>                                
                            </Row>
                            <Row>
                                <Col md="12" lg="6">
                                    <FormGroup className="required">
                                        <Label>Contractor</Label>
                                        <EInput
                                            type="select"
                                            name="contractor"
                                            id="contractor"
                                            required={true}
                                            value={this.state.well.contractor.id}
                                            onChange={this.handleSelectChange}
                                        >
                                            <option value="" />
                                            {this.state.contractorList.sort((a, b) => a.contractorName.localeCompare(b.contractorName)).map((contractor: IContractor, index: number) =>
                                                <option key={'contractor-op-' + index} value={contractor.id}>{contractor.contractorName}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="6">
                                    <FormGroup className="required">
                                        <Label>Rig Number</Label>
                                        <EInput
                                            type="text"
                                            name="rigNumber"
                                            id="rigNumber"
                                            required={true}
                                            value={this.state.well.rigNumber}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">    
                                    <FormGroup>
                                        <Label>Projected Depth</Label>
                                        <EInput
                                            type="text"
                                            name="projectedDepth"
                                            id="projectedDepth"
                                            data-validation="decimal"
                                            value={this.state.well.projectedDepth}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">    
                                    <FormGroup>
                                        <Label>Projected Cost</Label>
                                        <EInput
                                            type="text"
                                            name="projectedCost"
                                            id="projectedCost"
                                            data-mask="currency"
                                            data-validation="decimal"
                                            value={this.state.well.projectedCost}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">    
                                    <FormGroup>
                                        <Label>AFE Number</Label>
                                        <EInput
                                            type="text"
                                            name="afeNumber"
                                            id="afeNumber"
                                            value={this.state.well.afeNumber}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup className="required">
                                        <Label>Warehouse</Label>
                                        <EInput
                                            type="select"
                                            name="warehouseSelected"
                                            id="warehouseSelected"
                                            placeholder="Warehouse"
                                            required={true}
                                            onChange={this.handleWarehouseSelection}
                                            value={this.state.well.warehouseId}
                                        >
                                            <option />
                                            { this.state.warehouseList.map((w: IWarehouse, index: number) =>
                                                <option key={'warehouses-' + w.id} value={w.id}>{w.name}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Warehouse Phone</Label>
                                        <EInput
                                            type="text"
                                            name="warehousePhone"
                                            id="warehousePhone"
                                            placeholder="Warehouse Phone"
                                            disabled={true}
                                            value={this.state.well.warehouseId === '' ? '' : warehousePhone}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="12" lg="6">
                            <Row>
                                <Col md="12" className="legend clearfix">
                                    <div className="alternative-legend">Required before a well can be marked Complete</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="alternative">
                                        <Label>Well Type</Label>
                                        <EInput
                                            type="select"
                                            name="wellType"
                                            id="wellType"
                                            value={this.state.well.wellType}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value="" />
                                            <option value="Vertical">Vertical</option>
                                            <option value="Horizontal">Horizontal</option>
                                            <option value="Directional">Directional</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="alternative">
                                        <Label>Target Formation</Label>
                                        <EInput
                                            type="select"
                                            name="targetFormation"
                                            id="targetFormation"
                                            value={this.state.well.targetFormation}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            { this.state.targetFormationList.map((item: any) => 
                                                <option key={item.id} value={item.fieldItemName}>{item.fieldItemName}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" lg="6">
                                    <FormGroup className="alternative">
                                        <Label>API Number</Label>
                                        <EInput
                                            type="text"
                                            name="apiNumber"
                                            id="apiNumber"
                                            value={this.state.well.apiNumber}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="6">
                                    <FormGroup>
                                        <Label>Sidetrack Number</Label>
                                        <EInput
                                            type="text"
                                            name="sidetrack"
                                            id="sidetrack"
                                            value={this.state.well.sidetrack}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" lg="6">
                                    <FormGroup className="required">
                                        <Label>State</Label>
                                        <EInput
                                            type="select"
                                            name="state"
                                            id="state"
                                            value={this.state.well.state}
                                            onChange={this.handleStateChange}
                                            required={true}
                                        >
                                            <option disabled={true} />
                                            <option value="OK">Oklahoma</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="TX">Texas</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="6">
                                    <FormGroup className="required">
                                        <Label>County/Parish</Label>
                                        <EInput
                                            type="select"
                                            name="countyParish"
                                            id="countyParish"
                                            value={this.state.well.countyParish}
                                            onChange={this.handleCountyChange}
                                            required={true}
                                        >
                                            <option key={'county-select-empty'} value="" />
                                            {this.state.countyList &&
                                                this.state.countyList.map((county: any, index: number) =>
                                                    <option key={'county-select-' + index} value={county[0]}>{county[0]}</option>
                                                )
                                            }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" lg="6">
                                    <FormGroup className="alternative">
                                        <Label>Start Date</Label>
                                        <EInput
                                            type="date"
                                            name="startDate"
                                            id="startDate"
                                            value={this.state.well.startDate}
                                            onChange={this.handleDateChange}
                                        />

                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="6">
                                    <FormGroup>
                                        <Label>Spud Date</Label>
                                        <EInput
                                            type="date"
                                            name="spudDate"
                                            id="spudDate"
                                            value={this.state.well.spudDate}
                                            onChange={this.handleDateChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4" lg="4">
                                    <FormGroup className="required">
                                        <Label>Product Tax Rate</Label>
                                        <EInput
                                            type="select"
                                            name="productTaxRate"
                                            id="productTaxRate"
                                            required={true}
                                            value={this.state.well.productTaxRate}
                                            disabled={this.state.well.wellStatus !== 'Active'}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            {this.renderTaxRateOptions()}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="4">
                                    <FormGroup className="required">
                                        <Label>Rental Tax Rate</Label>
                                        <EInput
                                            type="select"
                                            name="rentalTaxRate"
                                            id="rentalTaxRate"
                                            required={true}
                                            value={this.state.well.rentalTaxRate}
                                            disabled={this.state.well.wellStatus !== 'Active'}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            {this.renderTaxRateOptions()}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="4">
                                    <FormGroup className="required">
                                        <Label>Service Tax Rate</Label>
                                        <EInput
                                            type="select"
                                            name="serviceTaxRate"
                                            id="serviceTaxRate"
                                            required={true}
                                            value={this.state.well.serviceTaxRate}
                                            disabled={this.state.well.wellStatus !== 'Active'}
                                            onChange={this.handleInputChange}
                                        >
                                            <option />
                                            {this.renderTaxRateOptions()}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <DataTable
                                list={this.state.dataSet}
                                onDelete={this.canRemoveEngineer() ? this.handleDelete : undefined}
                                onNew={this.canAddEngineer() ? {
                                    callback: this.toggleEngineerModal,
                                    text: 'Add User'
                                } : undefined}
                            />
                        </Col>
                    </Row>
                    <ButtonRow>
                        { !this.state.newWell && <WellRevertCloseButton />}
                        { !this.state.newWell && <WellCloseButton />}
                        { (this.state.newWell || this.WellsStore.canUpdateWell()) && <EButton name="save" color="primary" onClick={this.updateWellModel}>Save</EButton> }
                        { !this.state.newWell ? <Button name="next" className="secondary" onClick={this.buttonNavigation}>Next</Button> : "" }
                        { !this.state.newWell && <WellFooter />}
                    </ButtonRow>
                </Form>
                <Modal isOpen={this.state.addEngineerModal} toggle={this.toggleEngineerModal}>
                    <ModalHeader toggle={this.toggleEngineerModal}>Add a User</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Name</Label>
                                        <EInput
                                            type="select"
                                            name="selectedEngineer"
                                            id="selectedEngineer"
                                            placeholder="User Name"
                                            onChange={this.handleEngineerSelection}
                                            value={this.state.selectedEngineer}
                                            onKeyDown={this.handleKeyDown}
                                        >
                                            <option disabled={true} />
                                            { this.state.engineerList.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((engineer: IEngineer, index: number) =>
                                                !this.isContractorAvailable(engineer) &&
                                                    <option key={'engineer-select-' + index} value={index}>{engineer.firstName + ' ' + engineer.lastName}</option>
                                            )}
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Role</Label>
                                        <Input
                                            type="text"
                                            name="role"
                                            id="role"
                                            placeholder="User Role"
                                            disabled={true}
                                            value={this.state.newEngineer.roles[0] ? this.state.newEngineer.roles[0] : ''}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Location</Label>
                                        <EInput
                                            type="text"
                                            name="location"
                                            id="location"
                                            placeholder="Location"
                                            disabled={true}
                                            value={this.state.newEngineer.location}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup check={true} className="text-center">
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            id="active"
                                            placeholder="active"
                                            checked={this.state.newEngineer.active}
                                            onClick={this.handleActiveCheck()}
                                            disabled={this.state.newEngineer.roles && this.state.newEngineer.roles.some(r => r === 'Mud Engineer' || r === 'Senior Mud Engineer')}
                                        />Active
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Email</Label>
                                        <EInput
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Email"
                                            disabled={true}
                                            value={this.state.newEngineer.email}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Notifications</Label>
                                        <EInput
                                            type="text"
                                            name="phoneNumber"
                                            id="phoneNumber"
                                            placeholder="Home Phone"
                                            disabled={true}
                                            value={this.state.newEngineer.phoneNumber}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Mobile Phone</Label>
                                        <EInput
                                            type="text"
                                            name="phoneMobile"
                                            id="phoneMobile"
                                            placeholder="Mobile Phone"
                                            disabled={true}
                                            value={this.state.newEngineer.phoneMobile}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Alternate Phone</Label>
                                        <EInput
                                            type="text"
                                            name="phoneAlternate"
                                            id="phoneAlternate"
                                            placeholder="Alternate Phone"
                                            disabled={true}
                                            value={this.state.newEngineer.phoneAlternate}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleEngineerModal}>Cancel</Button>{' '}
                        <Button color="primary" id="saveAndClose" onClick={this.addEngineerToModel}>Update</Button>{' '}
                        <Button color="primary" id="addAnother" onClick={this.addEngineerToModel}>Add Another</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouter(WellDetails);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellDetails/WellDetails.tsx